import axios from 'axios';
import router from '../router';

const state = {
  categories: []
};

const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  }
};

const actions = {
  /**
   * Fetches a list of categories, optionally with a search query.
   */
  async fetchCategories({ commit }, { search = '' }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      const response = await axios.get(`${baseUrl}/categories`, {
        headers: { Authorization: `Bearer ${userToken}` },
        params: { search } // Include search parameter
      });
      commit('SET_CATEGORIES', response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error; // Let the component handle the error
    }
  },

  /**
   * Creates a new category.
   * The 'category' object should contain { categoryName, categoryDescription }
   */
  async createCategory({ dispatch }, { category }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.post(`${baseUrl}/categories`, category, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      // Refresh the list after creation
      dispatch('fetchCategories', { search: '' });
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  /**
   * Updates an existing category.
   * The 'category' object must contain the 'id' (or 'categoryId')
   */
  async updateCategory({ dispatch }, { category }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      // FIX: Use category.categoryId instead of category.id
      await axios.put(`${baseUrl}/categories/${category.categoryId}`, category, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      // Refresh the list
      dispatch('fetchCategories', { search: '' });
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },

  /**
   * Deletes a category.
   * The 'category' object must contain the 'id' (or 'categoryId')
   */
  async deleteCategory({ dispatch }, { category }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }

    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      // FIX: Use category.categoryId instead of category.id
      await axios.delete(`${baseUrl}/categories/${category.categoryId}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      // Refresh the list
      dispatch('fetchCategories', { search: '' });
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  }
};

const getters = {
  /**
   * Getter for the categories list
   */
  allCategories: (state) => state.categories
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};